import React from 'react';
import {
  FaCloud,
  FaCode,
  FaCogs,
  FaMobileAlt,
  FaServer,
  FaShoppingCart,
} from 'react-icons/fa';

const serviceIcons = {
  Web: FaCode,
  Mobile: FaMobileAlt,
  Server: FaServer,
  Commerce: FaShoppingCart,
  Cloud: FaCloud,
  Maintain: FaCogs,
};

function Services({ services }) {
  return (
    <section className="portfolioSection sectionReveal" id="services">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">Services</span>
        <h2>What I Can Build For You</h2>
        <p>
          From websites and mobile applications to APIs and complete software platforms, I build solutions tailored to your requirements.
        </p>
      </div>

      <div className="portfolioServices">
        {services.map((service) => {
          const Icon = serviceIcons[service.icon] || FaCode;
          return (
            <article className="portfolioServiceCard" key={service.title}>
              <div className="portfolioServiceCard__shine" aria-hidden="true" />
              <div className="portfolioServiceCard__icon">
                <Icon />
              </div>
              <div className="portfolioServiceCard__body">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
              <div className="portfolioTags portfolioTags--small">
                {service.technologies.map((tech) => <span key={tech}>{tech}</span>)}
              </div>
              <div className="portfolioServiceCard__flow" aria-hidden="true">
                {service.technologies.slice(0, 4).map((tech) => <span key={tech}>{tech}</span>)}
              </div>
              <a href="#contact" className="portfolioServiceCard__cta">Scope this</a>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default Services;
